import React from 'react';
import { Icon } from './Icon.js';
export const IconWindowBottomFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M9.25 1C10.7688 1 12 2.23122 12 3.75V8.25C12 9.76878 10.7688 11 9.25 11H2.75C1.23122 11 0 9.76878 0 8.25V3.75C0 2.23122 1.23122 1 2.75 1H9.25ZM2.75 6C2.33579 6 2 6.33579 2 6.75V8.25C2 8.66421 2.33579 9 2.75 9H9.25C9.66421 9 10 8.66421 10 8.25V6.75C10 6.33579 9.66421 6 9.25 6H2.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconWindowBottomFill12.js.map